// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"172":"global","520":"frame","690":"lottie-player","893":"products","895":"tools"}[chunkId] || chunkId) + "." + {"172":"eec04b4c","483":"075a1dbb","520":"d3ed978f","690":"27f5cd81","715":"3e86bf83","886":"b64cca8d","893":"d0e62825","895":"c0539e23","944":"00c0a977"}[chunkId] + ".js";
};